/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-nested-ternary */
import { zodResolver } from "@hookform/resolvers/zod";
import AuthTurnstile from "components/auth/AuthTurnstile";
import { forgotPasswordDataShape } from "components/auth/form";
import { Button } from "components/ui/Button";
import { Form, FormField, FormMessage } from "components/ui/Form";
import { Input } from "components/ui/Input";
import { useState, type ReactElement } from "react";
import { useForm } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";

interface IForgotPasswordFormValues {
  email: string;
  turnstileToken: string;
  turnstileIdempotencyKey: string;
}

interface IForgotPasswordFormProps {
  onSubmit: (values: IForgotPasswordFormValues) => void;
}

export default function ForgotPasswordForm({ onSubmit }: IForgotPasswordFormProps): ReactElement {
  const intl = useIntl();
  const [turnstileIdempotencyKey] = useState(() => crypto.randomUUID());

  const form = useForm({
    mode: "onSubmit",
    resolver: zodResolver(forgotPasswordDataShape(intl)),
    defaultValues: {
      email: "",
      turnstileToken: "",
    },
  });

  const {
    formState: { isSubmitting, isSubmitSuccessful },
  } = form;

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit((values) => onSubmit({ ...values, turnstileIdempotencyKey }))}
        className="grid gap-y-5"
      >
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => {
            return (
              <div className="space-y-2">
                <Input
                  {...field}
                  height={44}
                  type="email"
                  spellCheck={false}
                  autoComplete="off"
                  placeholder="Email"
                  name="email"
                  maxLength={256}
                  disabled={isSubmitSuccessful}
                />

                <FormMessage />
              </div>
            );
          }}
        />

        <Button type="submit" disabled={isSubmitting} variant="default">
          {isSubmitting ? (
            <FormattedMessage defaultMessage="Aguarde..." id="VZazm7" />
          ) : isSubmitSuccessful ? (
            <FormattedMessage defaultMessage="Pronto!" id="X7b4K6" />
          ) : (
            <FormattedMessage defaultMessage="Recuperar senha" id="l90XD1" />
          )}
        </Button>

        <FormField
          control={form.control}
          name="turnstileToken"
          render={({ field }) => <AuthTurnstile onSuccess={field.onChange} />}
        />
      </form>
    </Form>
  );
}
